import { all } from "redux-saga/effects";
import AuthSagas from "./authsagas";

export default function* rootSaga() {
  yield all([...AuthSagas]);
}
